<template>
  <div
    v-if='shouldDisplay'
    class='mt-4 flex flex-col gap-4 rounded-lg border border-dashed border-green-200 bg-green-50/70 p-4 text-sm text-gray-700 sm:flex-row sm:items-center'
  >
    <img
      :src='qrCodeSrc'
      alt='TOTP QR Code'
      class='h-36 w-36 rounded bg-white p-2 shadow'
    >
    <div class='space-y-2'>
      <div class='font-semibold text-gray-900'>Scan this QR code with your authenticator app.</div>
      <p class='text-xs text-gray-600'>After scanning, enter the code generated by your app to complete verification.</p>
      <div
        v-if='totpSecret'
        class='rounded border border-white bg-white/80 px-3 py-2 font-mono text-xs text-gray-800'
      >
        Secret: {{ totpSecret }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import type { VerificationActionMethodResult } from '@/api/requests/verification/verificationResponses'

  const props = defineProps<{ methodResult: VerificationActionMethodResult }>()

  const isTotp = computed(() => props.methodResult.methodType.toLowerCase() === 'totp')

  const totpData = computed(() => {
    if (!isTotp.value) {
      return null
    }

    return props.methodResult.data as Record<string, unknown> | null
  })

  const qrCodeSrc = computed(() => {
    const qr = (totpData.value?.qrCode as string | undefined) ?? null

    if (!qr) {
      return null
    }

    return qr.startsWith('data:') ? qr : `data:image/png;base64,${qr}`
  })

  const totpSecret = computed(() => (totpData.value?.totpSecret as string | undefined) ?? null)

  const shouldDisplay = computed(() => Boolean(isTotp.value && qrCodeSrc.value))

</script>
